function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineIntegration, getLocationHref } from '@sentry/core';
import { WINDOW } from '../helpers.js';
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */

var httpContextIntegration = defineIntegration(() => {
  return {
    name: 'HttpContext',

    preprocessEvent(event) {
      var _event$request, _event$request2;

      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      } // grab as much info as exists and add it to the event


      var url = ((_event$request = event.request) === null || _event$request === void 0 ? void 0 : _event$request.url) || getLocationHref();
      var {
        referrer
      } = WINDOW.document || {};
      var {
        userAgent
      } = WINDOW.navigator || {};

      var headers = _objectSpread(_objectSpread(_objectSpread({}, (_event$request2 = event.request) === null || _event$request2 === void 0 ? void 0 : _event$request2.headers), referrer && {
        Referer: referrer
      }), userAgent && {
        'User-Agent': userAgent
      });

      var request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
        url
      }), {}, {
        headers
      });

      event.request = request;
    }

  };
});
export { httpContextIntegration };